import announceRoutes from './routes'

/* @ngInject */
const announceRun = (
  $transitions,
  maneuverMenu,
  storageHandler,
  $state,
  $$owner,
) => {
  $transitions.onSuccess({
    entering: announceRoutes.index.path,
  }, (trans) => {
    maneuverMenu.radio.value = 'announceMenu'

    const step = storageHandler.get('maneuver.announce.step')

    if (step === 'selectWagons') {
      $state.go(announceRoutes.selectWagons.path)
    } else if (step === 'report') {
      $state.go(announceRoutes.report.path)
    } else if (!step) {
      $state.go(announceRoutes.selectWagons.path)
    }
  })

  $transitions.onBefore({
    from: announceRoutes.index.path,
  }, (trans) => {

  })

  $transitions.onBefore({
    entering: announceRoutes.selectWagons.path,
  }, async (trans) => {
    const response = await $$owner.request.getAll()
    $$owner.data.myOwners = response.owners
  })
}

export default announceRun



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/announce/announce.run.js